export default{
  "Video Compressor": "Видео Компрессор",
  "HitPaw Online Video Compressor": "HitPaw Online Video Compressor (Компрессор видео онлайн)",
  "Best video compressor tool to reduce video file size online without losing quality.": "Лучший инструмент для сжатия видео для уменьшения размера видеофайла в Интернете без потери качества.",
  "Quality": "Качество",
  "Small Size": "Маленький размер ({{num}}%)",
  "High Quality": "Высокое качество ({{num}}%)",
  "Frame Rate": "Частота кадров",
  "Resolution": "Разрешение",
  "Keep Resolution": "Сохранить разрешение",
  "Format": "Формат",
  "Compress": "Сжать",
  "Compressing": "Сжатие",
  "Compress New": "Сжать новый",
  "xx% reduction in size!": "уменьшение размера на {{num}}%!",
  "Compressed successfully, your file is now xxMB.": "Ваш файл успешно сжат, теперь размер вашего файла <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Сжатие не удалось",
};